.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.inline {
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.inline .label {
  width: 120px;
  flex: none;
}

.label {
  font-size: 12px;
  color: var(--c-text-tertiary);
  font-weight: 500;
}

.hint {
  font-size: 12px;
  color: var(--c-text-tertiary);
  line-height: 1.45;
}

.error {
  font-size: 12px;
  color: var(--c-negative);
}

.input {
  width: 100%;
  height: var(--control-height);
  padding: 0 10px;
  border-radius: 10px;
  border: 1px solid var(--c-border);
  background: var(--c-surface-sunken);
  color: var(--c-text-primary);
  font-size: var(--text-caption);
  outline: none;
}

.input:focus {
  border-color: var(--c-brand);
}

.invalid {
  border-color: var(--c-negative);
}

.count {
  align-self: flex-end;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--c-text-tertiary);
}

.countNearly {
  color: var(--c-warning);
}

.mono {
  font-family: var(--font-mono);
}

.textarea {
  height: auto;
  min-height: 90px;
  padding: 8px 10px;
  resize: vertical;
  line-height: 1.5;
}

.selectWrap {
  position: relative;
  display: inline-flex;
  min-width: 0;
}

.select {
  appearance: none;
  padding-right: 30px;
  cursor: pointer;
}

.selectIcon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: var(--c-text-tertiary);
}

.search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: var(--control-height);
  padding: 0 10px;
  border-radius: 10px;
  background: var(--c-surface-sunken);
  border: 1px solid var(--c-border);
  color: var(--c-text-tertiary);
  min-width: 0;
}

.search:focus-within {
  border-color: var(--c-brand);
}

.search input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--c-text-primary);
  font-size: var(--text-caption);
}

.search input::-webkit-search-cancel-button {
  display: none;
}

.toggle {
  position: relative;
  width: 34px;
  height: 20px;
  flex: none;
  border-radius: 20px;
  border: 1px solid var(--c-border);
  background: var(--c-surface-elevated);
  padding: 0;
  transition: background var(--motion-fast);
}

.toggleOn {
  background: var(--c-brand);
  border-color: var(--c-brand);
}

.knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: var(--c-text-tertiary);
  transition:
    transform var(--motion-fast),
    background var(--motion-fast);
}

.toggleOn .knob {
  transform: translateX(14px);
  background: var(--c-on-brand);
}

.slider {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.slider input {
  flex: 1;
  min-width: 80px;
  accent-color: var(--c-brand);
}

.sliderValue {
  /* Fixed, not min: a readout that widens from "5" to "100" shortens the track mid-drag. The
     component widens it to its longest reading; this is the floor. */
  width: 72px;
  flex: none;
  white-space: nowrap;
  justify-content: center;
  font-variant-numeric: tabular-nums;
  height: 30px;
  padding: 0 6px;
  border-radius: var(--radius-sm);
  background: var(--c-surface-sunken);
  border: 1px solid var(--c-border);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: var(--text-caption);
  font-weight: 500;
}

.checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-caption);
  cursor: pointer;
}

.checkbox input {
  accent-color: var(--c-brand);
  width: 16px;
  height: 16px;
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Password field: the input keeps its full width and the eye sits inside its right edge. */
.passwordWrap {
  position: relative;
}

.passwordInput {
  padding-right: 38px;
}

.passwordEye {
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
  color: var(--c-text-tertiary);
}
